enum DealCustomerTypeEnum {
  MainApplicant = 1,
  CoApplicant = 2,
  Seller = 3,
}

export default DealCustomerTypeEnum;
